<template>
  <div>
    <el-select v-model="exhibitionId" placeholder="請選擇展覽" @change="getDailyHoroscopeImages()" style="width: 100%">
      <el-option-group
        v-for="group in exhibitionOptions"
        :key="group.label"
        :label="group.label">
        <el-option
          v-for="item in group.options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-option-group>
      <!--
      <el-option
        v-for="item in exhibitionOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
      -->
    </el-select>
    <div v-if="exhibitionId">
      <div style="border: 1px black solid; margin-top: 20px; border-radius: 5px">
        <el-row>
          <el-col :span="12" style="text-align: center; padding: 10px; font-weight: bolder">
            <span>中文</span>
          </el-col>
          <el-col :span="12" style="text-align: center; padding: 10px; font-weight: bolder">
            <span>英文</span>
          </el-col>
        </el-row>
        <el-row style="border-top: black 1px solid">
          <el-col :span="12" style="text-align: center; padding: 10px">
            <div class="image-content horoscope-image demo-image__error">
              <div class="block">
                <el-image :src="getHoroscopeImage('ZH')" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
            <input id="zhFileInput" type="file" @change="onZHImagesChange" accept="image/jpeg, image/png" hidden>
            <div style="margin-top: 20px">
              <el-button @click="handleZHUploadImage">{{ zhHoroscope && zhHoroscope.images.length > 0 ? zhHoroscope.images[0]['original_name'] : '選擇檔案' }}</el-button>
              <el-button v-if="uploadZHImages.length > 0" plain @click="removeZHUploadImage">移除所選檔案</el-button>
            </div>
          </el-col>
          <el-col :span="12" style="text-align: center; padding: 10px">
            <div class="image-content horoscope-image demo-image__error">
              <div class="block">
                <el-image :src="getHoroscopeImage('EN')" fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </div>
            <input id="enFileInput" type="file" @change="onENImagesChange" accept="image/jpeg, image/png" hidden>
            <div style="margin-top: 20px">
              <el-button @click="handleENUploadImage">{{ enHoroscope && enHoroscope.images.length > 0 ? enHoroscope.images[0]['original_name'] : '選擇檔案' }}</el-button>
              <el-button v-if="uploadENImages.length > 0" plain @click="removeENUploadImage">移除所選檔案</el-button>
            </div>
          </el-col>
          <el-col :span="12" style="text-align: center; padding: 10px">
            <span>點擊次數 : 0</span>
          </el-col>
          <el-col :span="12" style="text-align: center; padding: 10px">
            <span>點擊次數 : 0</span>
          </el-col>
        </el-row>
      </div>
      <el-button
        class="tfam-button"
        plain
        v-loading.fullscreen.lock="fullLoading"
        @click="handelSubmitUpdate"
        style="margin-top: 20px"
        :disabled="uploadENImages.length === 0 && uploadZHImages.length === 0">更新並儲存</el-button>
    </div>
  </div>
</template>

<script>
  import { fetchImageList, createImage, deleteImage } from "../../api/image";
  import { getGCPFileUrl, storageUploadFiles } from "../../api/attachment";
  import { fetchHoroscopeList, createHoroscope, updateHoroscope, deleteHoroscope } from "../../api/horoscope";
  import { fetchExhibitionList } from "../../api/exhibition";
  import lodash from 'lodash'

  export default {
    name: "DailyHoroscope",
    data() {
      return {
        fullLoading: false,
        exhibitionList: [],
        exhibitionOptions: [],
        exhibitionId: undefined,
        horoscopes: [],
        originalZHHoroscope: undefined,
        zhHoroscope: undefined,
        originalENHoroscope: undefined,
        enHoroscope: undefined,
        uploadZHImages: [],
        uploadENImages: [],
      }
    },
    filters: {
    },
    methods: {
      tapCountFilter: function (row) {
        return 0
      },
      getHoroscopeImage(language) {
        if (language === 'ZH') {
          if (this.uploadZHImages.length > 0) {
            return this.zhHoroscope.images[0]['file'];
          } else {
            if (this.zhHoroscope && this.zhHoroscope.images.length > 0) {
              return getGCPFileUrl(this.zhHoroscope.images[0]['name']);
            } else {
              return ''
            }
          }
        } else if (language === 'EN') {
          if (this.uploadENImages.length > 0) {
            return this.enHoroscope.images[0]['file'];
          } else {
            if (this.enHoroscope && this.enHoroscope.images.length > 0) {
              return getGCPFileUrl(this.enHoroscope.images[0]['name']);
            } else {
              return ''
            }
          }
        } else {
          return ''
        }
      },
      onZHImagesChange(event){
        const files = event.target.files;
        if (files) {
          const files_count = files.length;
          for (let i = 0; i < files_count; i++){
            const reader = new FileReader();
            reader.onload = (e) => {
              this.zhHoroscope['images'] = [];
              this.zhHoroscope['images'] = [{
                file: e.target.result,
                name: files[i]['name'],
                original_name: files[i]['name']
              }];
              this.uploadZHImages = files;
            };
            reader.readAsDataURL(files[i]);
          }
        }
      },
      handleZHUploadImage() {
        document.getElementById("zhFileInput").click()
      },
      removeZHUploadImage() {
        this.zhHoroscope.images = lodash.cloneDeep(this.originalZHHoroscope.images);
        this.uploadZHImages = [];
        if (document.getElementById("zhFileInput")) {
          document.getElementById("zhFileInput").value = '';
        }
      },
      onENImagesChange(event){
        const files = event.target.files;
        if (files) {
          const files_count = files.length;
          for (let i = 0; i < files_count; i++){
            const reader = new FileReader();
            reader.onload = (e) => {
              this.enHoroscope['images'] = [];
              this.enHoroscope['images'] = [{
                file: e.target.result,
                name: files[i]['name'],
                original_name: files[i]['name']
              }];
              this.uploadENImages = files;
            };
            reader.readAsDataURL(files[i]);
          }
        }
      },
      handleENUploadImage() {
        document.getElementById("enFileInput").click()
      },
      removeENUploadImage() {
        this.enHoroscope.images = lodash.cloneDeep(this.originalENHoroscope.images);
        this.uploadENImages = [];
        if (document.getElementById("enFileInput")) {
          document.getElementById("enFileInput").value = '';
        }
      },
      getExhibitions() {
        this.fullLoading = true;
        const filter = {
          where: {
            // status: 'online'
            // or: [{
            //   status: 'online'
            // }, {
            //   status: 'keep'
            // }]
          },
          order: 'open_start_at DESC',
          include: [{
            relation: 'exhibitionLangs',
            scope: {
              where: {
                language_key: 'ZH_TW'
              }
            }
          }]
        };
        fetchExhibitionList(filter).then(res => {
          this.fullLoading = false;
          this.exhibitionList = res.data;
          this.exhibitionOptions = [];
          const filterOnline = this.exhibitionList.filter(x => x['status'] === 'online' || x['status'] === 'keep');
          const onlineOptions = [];
          for (const i in filterOnline) {
            const exhibition = filterOnline[i];
            onlineOptions.push({
              label: exhibition['exhibitionLangs'][0]['title'],
              value: exhibition['exhibition_id']
            })
          }
          this.exhibitionOptions.push({
            label: '上架中',
            options: onlineOptions
          });
          const filterPrepare = this.exhibitionList.filter(x => x['status'] === 'prepare');
          const prepareOptions = [];
          for (const i in filterPrepare) {
            const exhibition = filterPrepare[i];
            prepareOptions.push({
              label: exhibition['exhibitionLangs'][0]['title'],
              value: exhibition['exhibition_id']
            })
          }
          this.exhibitionOptions.push({
            label: '準備中',
            options: prepareOptions
          });
          const filterHistory = this.exhibitionList.filter(x => x['status'] === 'history');
          const historyOptions = [];
          for (const i in filterHistory) {
            const exhibition = filterHistory[i];
            historyOptions.push({
              label: exhibition['exhibitionLangs'][0]['title'],
              value: exhibition['exhibition_id']
            })
          }
          this.exhibitionOptions.push({
            label: '歷史展覽',
            options: historyOptions
          });
          // if (this.exhibitionList.length > 0) {
          //   this.exhibitionId = this.exhibitionList[0]['exhibition_id'];
          //   this.getDailyHoroscopeImages()
          // }
        }).catch(e => {
          this.fullLoading = false;
        })
      },
      getDailyHoroscopeImages() {
        console.log(this.exhibitionId);
        this.fullLoading = true;
        const filter = {
          where: {
            exhibition_id: this.exhibitionId
          }
        };
        fetchHoroscopeList(filter).then(res => {
          this.fullLoading = false;
          this.horoscopes = res.data;
          this.setupDailyHoroscopes();
        }).catch(e => {
          this.fullLoading = false;
        })
      },
      setupDailyHoroscopes() {
        this.uploadZHImages = [];
        this.uploadENImages = [];
        const filterZH = this.horoscopes.filter(x => x['language_key'] === 'ZH_TW');
        if (filterZH.length > 0) {
          this.originalZHHoroscope = filterZH[0];
          this.zhHoroscope = lodash.cloneDeep(this.originalZHHoroscope)
        } else {
          this.originalZHHoroscope = {
            horoscope_id: 'new',
            images: [],
            language_key: 'ZH_TW',
            exhibition_id: this.exhibitionId
          };
          this.zhHoroscope = lodash.cloneDeep(this.originalZHHoroscope)
        }
        const filterEN = this.horoscopes.filter(x => x['language_key'] === 'EN');
        if (filterEN.length > 0) {
          this.originalENHoroscope = filterEN[0];
          this.enHoroscope = lodash.cloneDeep(this.originalENHoroscope)
        } else {
          this.originalENHoroscope = {
            horoscope_id: 'new',
            images: [],
            language_key: 'EN',
            exhibition_id: this.exhibitionId
          };
          this.enHoroscope = lodash.cloneDeep(this.originalENHoroscope)
        }
      },
      handelSubmitUpdate() {
        this.fullLoading = true;
        this.submitUpdate().then(() => {
          this.fullLoading = false;
          this.getDailyHoroscopeImages();
        }).catch(e => {
          this.fullLoading = false;
          console.log(e)
        })
      },
      submitUpdate: async function () {
        try {
          let zhHoroscopeId = this.zhHoroscope.horoscope_id;
          let enHoroscopeId = this.enHoroscope.horoscope_id;
          if (zhHoroscopeId === 'new') {
            const newHoroscopeResult = await createHoroscope({
              'language_key': 'ZH_TW',
              'exhibition_id': this.zhHoroscope.exhibition_id
            });
            zhHoroscopeId = newHoroscopeResult.data['horoscope_id']
          }
          if (enHoroscopeId === 'new') {
            const newHoroscopeResult = await createHoroscope({
              'language_key': 'EN',
              'exhibition_id': this.enHoroscope.exhibition_id
            });
            enHoroscopeId = newHoroscopeResult.data['horoscope_id']
          }
          if (this.uploadZHImages.length > 0) {
            const uploadResult = await storageUploadFiles(this.uploadZHImages);
            const files = uploadResult.data.result.files.file;
            const fileName = files[0]['name'];
            const originalFilename = files[0]['originalFilename'];
            await createImage({
              name: fileName,
              original_name: originalFilename,
              object_id: zhHoroscopeId
            });
            if (this.originalZHHoroscope.images.length > 0) {
              for (const i in this.originalZHHoroscope.images) {
                const imageId = this.originalZHHoroscope.images[i]['image_id'];
                await deleteImage(imageId);
              }
            }
          }
          if (this.uploadENImages.length > 0) {
            const uploadResult = await storageUploadFiles(this.uploadENImages);
            const files = uploadResult.data.result.files.file;
            const fileName = files[0]['name'];
            const originalFilename = files[0]['originalFilename'];
            await createImage({
              name: fileName,
              original_name: originalFilename,
              object_id: enHoroscopeId
            });
            if (this.originalENHoroscope.images.length > 0) {
              for (const i in this.originalENHoroscope.images) {
                const imageId = this.originalENHoroscope.images[i]['image_id'];
                await deleteImage(imageId);
              }
            }
          }
          return Promise.resolve(true);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    mounted() {
      // this.getDailyHoroscopeImages()
      this.getExhibitions()
    }
  }
</script>

<style scoped lang="scss">
.tfam-button {
  margin-bottom: 20px;
}
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain;
}
</style>
